import { Box, useShadow, useTheme } from "@seneca/senekit";

import useEffectOnUnmount from "seneca-common/utils/hooks/useEffectOnUnmount";

import {
  addBodyScrollLock,
  removeBodyScrollLock
} from "features/common/containers/ModalBodyScrollLocker";

type Props = {
  opened: boolean;
  children: React.ReactNode;
  lockBodyScroll?: boolean;
};

export default function SidebarSkeleton({
  children,
  opened,
  lockBodyScroll
}: Props) {
  const theme = useTheme();
  const shadow = useShadow("large");

  useEffectOnUnmount(removeBodyScrollLock);

  return (
    <Box
      backgroundColor={theme.foreground}
      boxShadow={opened ? shadow : "none"}
      height="100%"
      position="relative"
      display="flex"
      flexDirection="column"
    >
      {lockBodyScroll ? (
        <div onTouchStart={addBodyScrollLock} onTouchEnd={removeBodyScrollLock}>
          {children}
        </div>
      ) : (
        children
      )}
    </Box>
  );
}
